module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gt-d15a032ec515a61d320ca71b1548a8a5.svg";